// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from file-generic.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function FileGenericIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M12.333 0a.5.5 0 0 1 .352.144l2.167 2.143a.5.5 0 0 1 .148.356V15.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5h10.833ZM11 1H2v14h12V4h-2.5a.5.5 0 0 1-.5-.5V1Zm-3.75 9.5a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5Zm4-2.75a.75.75 0 1 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h6.5Zm0-2.75a.75.75 0 1 1 0 1.5h-6.5a.75.75 0 0 1 0-1.5h6.5Z"
      />
    </svg>
  );
}
